(() => {
  if (window.iceGuysQuickViewGalleryDelegationLoaded) return;
  window.iceGuysQuickViewGalleryDelegationLoaded = true;

  function pauseVideos(gallery) {
    gallery.querySelectorAll('video').forEach((video) => {
      try {
        video.pause();
        video.currentTime = 0;
      } catch (error) {}
    });
  }

  function playVideo(media) {
    const video = media?.querySelector('video');
    if (!video) return;

    try {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;

      const playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    } catch (error) {}
  }

  function activateThumbnail(thumbnail) {
    const gallery = thumbnail.closest('.ig-media-gallery');
    if (!gallery) return;

    const manualTarget = thumbnail.getAttribute('data-media-target');
    const nativeTarget = thumbnail.getAttribute('data-native-target');

    const isManual = Boolean(manualTarget);
    const isNative = Boolean(nativeTarget);

    if (!isManual && !isNative) return;

    const targetValue = isManual ? manualTarget : nativeTarget;
    const mediaSelector = isManual ? '.ig-main-media' : '.ig-native-media';
    const mediaAttribute = isManual
      ? 'data-media-id'
      : 'data-native-media-id';

    const allMedia = Array.from(
      gallery.querySelectorAll(mediaSelector)
    );

    const selectedMedia = allMedia.find(
      (media) =>
        String(media.getAttribute(mediaAttribute)) ===
        String(targetValue)
    );

    if (!selectedMedia) return;

    pauseVideos(gallery);

    allMedia.forEach((media) => {
      media.setAttribute('data-active', 'false');
    });

    selectedMedia.setAttribute('data-active', 'true');

    gallery
      .querySelectorAll('.ig-media-thumbnail')
      .forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-selected', 'false');
      });

    thumbnail.classList.add('is-active');
    thumbnail.setAttribute('aria-selected', 'true');

    requestAnimationFrame(() => {
      playVideo(selectedMedia);
    });
  }

  document.addEventListener(
    'click',
    (event) => {
      const target =
        event.target instanceof Element
          ? event.target
          : null;

      if (!target) return;

      const thumbnail = target.closest(
        '#quick-add-modal-content .ig-media-thumbnail'
      );

      if (!thumbnail) return;

      event.preventDefault();
      event.stopPropagation();

      activateThumbnail(thumbnail);
    },
    true
  );
})();